import { Container, AppIcon, AppName, LogoLink } from './styles';

const Header = () => {
    return (
        <Container>
            <LogoLink href="/">
                <AppIcon src="/assets/icon.png" alt="AprèsStory" />
                <AppName>AprèsStory</AppName>
            </LogoLink>
        </Container>
    );
}

export default Header;
